/**
 * These Sample names define the possible query options.
 */
export var SampleNames;
(function (SampleNames) {
    SampleNames["STEP_COUNT"] = "stepCount";
    SampleNames["FLIGHTS_CLIMBED"] = "flightsClimbed";
    SampleNames["APPLE_EXERCISE_TIME"] = "appleExerciseTime";
    SampleNames["ACTIVE_ENERGY_BURNED"] = "activeEnergyBurned";
    SampleNames["BASAL_ENERGY_BURNED"] = "basalEnergyBurned";
    SampleNames["DISTANCE_WALKING_RUNNING"] = "distanceWalkingRunning";
    SampleNames["DISTANCE_CYCLING"] = "distanceCycling";
    SampleNames["BLOOD_GLUCOSE"] = "bloodGlucose";
    SampleNames["SLEEP_ANALYSIS"] = "sleepAnalysis";
    SampleNames["WORKOUT_TYPE"] = "workoutType";
    SampleNames["WEIGHT"] = "weight";
    SampleNames["HEART_RATE"] = "heartRate";
    SampleNames["RESTING_HEART_RATE"] = "restingHeartRate";
    SampleNames["RESPIRATORY_RATE"] = "respiratoryRate";
    SampleNames["BODY_FAT"] = "bodyFat";
    SampleNames["OXYGEN_SATURATION"] = "oxygenSaturation";
    SampleNames["BASAL_BODY_TEMPERATURE"] = "basalBodyTemperature";
    SampleNames["BODY_TEMPERATURE"] = "bodyTemperature";
    SampleNames["BLOOD_PRESSURE_SYSTOLIC"] = "bloodPressureSystolic";
    SampleNames["BLOOD_PRESSURE_DIASTOLIC"] = "bloodPressureDiastolic";
})(SampleNames || (SampleNames = {}));
//# sourceMappingURL=definitions.js.map